import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doc, getDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { firestore } from "firebaseConfig";

export const getClientDetails = createAsyncThunk(
  "ClientDetails/getClientDetails",
  async ({ id }, thunkAPI) => {
    try {
      const ref = doc(firestore, "clientdetail", id);
      const snapshot = await getDoc(ref);

      if (snapshot.exists()) {
        return { clientData: snapshot.data() };
      } else {
        console.log("No data found");
        return { clientData: null };
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const ClientDetailsSlice = createSlice({
  name: "ClientDetails",
  initialState: {
    clientDetailsData: {},
    isFetching: false,
    message: "",
    isSuccess: false,
    isError: false,
  },
  reducers: {
    clearState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isFetching = false;
      state.message = null;
      return state;
    },
  },
  extraReducers: {
    [getClientDetails.fulfilled]: (state, { payload }) => {
      state.clientDetailsData = payload.clientData;
      state.isFetching = false;
      state.message = "Successfully added!!";
    },
    [getClientDetails.pending]: (state) => {
      state.isFetching = true;
    },
    [getClientDetails.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.message = payload?.message || "Server Error";
    },
  },
});

export const { clearState } = ClientDetailsSlice.actions;
export const clientDetailsSelector = (state) => state.clientDetails;
